import React from "react"
import {FieldViewProps} from "../../render/view"

const debug = false
// const debug = "FieldProto_GraphTooltipView"

export default function FieldProto_GraphTooltipView(props: FieldViewProps) {

    const {label, value} = props.params

    debug && console.log(debug, 'render', props)

    return (
        <div className="gd-ui-hint-popover">
            <div className="popover-container">
                <div className="popover-content">
                    <div className="hint-text">
                        {'{0}: {1}'.f(label, value)}
                    </div>
                </div>
            </div>
        </div>
    )
}